import { exportTable, getSIMTables, getSIMData } from 'redux/api/Lists'

import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { FileExtension } from 'utils/types'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

export function tryGetListTables() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getTables())

    getSIMTables()
      .then((response) => {
        dispatch(actions.getTablesSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getTablesFailed())
      })
  }
}

export function tryGetListData(id: string, queryString: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getData({ tableId: id }))

    getSIMData(id, queryString)
      .then((response) => {
        dispatch(
          actions.getDataSuccess({
            data: { ...response.data.data, tableId: id }
          })
        )
      })
      .catch(() => {
        dispatch(actions.getDataFailed())
      })
  }
}

export function tryExportListTable(
  id: string,
  tableName: string,
  extension: FileExtension,
  queryString: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.exportTable())

    exportTable(id, extension, queryString)
      .then((response) => {
        const fileName = `${tableName}.${extension}`
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        )
        const link = document.createElement('a')

        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()

        dispatch(actions.exportTableSuccess())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.exportTableFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export const useListsActions = () => {
  return {
    tryGetListTables: useThunkActions(tryGetListTables),
    tryGetListData: useThunkActions(tryGetListData),
    tryExportListTable: useThunkActions(tryExportListTable)
  }
}
